import { CheckoutConfig, CheckoutStepType, DeliveryModePreferences } from "@spartacus/checkout/base/root";

export const genCheckoutConfig: CheckoutConfig = {
  checkout: {
    steps: [
      {
        id: 'engineReplacementForm',
        name: 'checkoutProgress.engineReplacementFormTab',
        routeName: 'checkoutEngineReplacementForm',
        type: [CheckoutStepType.ENGINE_REPLACEMENT_FORM],
        nameMultiLine: false,
      },
      {
        id: 'deliveryAddress',
        name: 'checkoutProgress.deliveryAddress',
        routeName: 'checkoutDeliveryAddress',
        type: [CheckoutStepType.DELIVERY_ADDRESS],
        nameMultiLine: false,
      },
      {
        id: 'finishedGoods',
        name: 'checkoutProgress.finishedGoods',
        routeName: 'checkoutFinishedGoods',
        type: [CheckoutStepType.FINISHED_GOODS],
        nameMultiLine: false,
      },
      {
        id: 'serviceParts',
        name: 'checkoutProgress.serviceParts',
        routeName: 'checkoutServiceParts',
        type: [CheckoutStepType.SERVICE_PARTS],
        nameMultiLine: false,
      },
      {
        id: 'subscriptionInfo',
        name: 'checkoutProgress.subscriptionInfo',
        routeName: 'checkoutSubscriptionInfo',
        type: [CheckoutStepType.SUBSCRIPTION_INFORMATION],
        nameMultiLine: false,
      },
      {
        id: 'specialHandling',
        name: 'checkoutProgress.specialHandlingTab',
        routeName: 'checkoutSpecialHandling',
        type: [CheckoutStepType.SPECIAL_HANDLING],
        nameMultiLine: false,
      },
      {
        id: 'paymentType',
        name: 'checkoutProgress.paymentDetails',
        routeName: 'checkoutPaymentType',
        type: [CheckoutStepType.PAYMENT_TYPE],
        nameMultiLine: false,
      },
      {
        id: 'reviewOrder',
        name: 'checkoutProgress.reviewOrder',
        routeName: 'checkoutReviewOrder',
        type: [CheckoutStepType.REVIEW_ORDER],
        nameMultiLine: false,
      },
    ],
    express: false,
    defaultDeliveryMode: [DeliveryModePreferences.FREE],
    guest: false,
  },
}